import interceptor from "../common/interceptor";
import { APIPaths } from "../common/constants";

//<!-------On Bording Steps-------->
//Step 1[Couriers]

export const GetCouriers = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.getAllCouriers, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Link Account
export const LinkAccount = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.settingsCourier, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteCourierAccount = (id, token) => {
  const url = `${APIPaths.settingsCourier}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteSettingsCourierAccount = (id, token) => {
  const url = `${APIPaths.courierContacts}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSingleCourierById = (token, id) => {
  const url = `${APIPaths.settingsCourier}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// export const GetSingleCourierById = (token, id) => {
//   const url = `${APIPaths.settingsCourier}${id}/`;
//   return new Promise((resolve, reject) => {
//     interceptor
//       .axiosGet("Get", url, token, null)
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((error) => {
//         console.log("error?.response?.data?.error", error?.response);
//         reject(error?.response);
//       });
//   });
// };

//Step2 [Products]
export const AddProducts = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.products, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetProducts = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.products, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetProductById = (token, id) => {
  const url = `${APIPaths.products}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteProduct = (id, token) => {
  const url = `${APIPaths.products}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Step3 [Sensors]

export const GetSensors = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.getAllSensors, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const LinkSensorsAccount = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.linkSensorsAccount, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteSensor = (id, token) => {
  const url = `${APIPaths.linkSensorsAccount}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSensorById = (token, id) => {
  const url = `${APIPaths.linkSensorsAccount}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//step 5
export const AddUsers = (token, model, isSignup) => {
  return new Promise((resolve, reject) => {
    const url = `${APIPaths.users}?is_signup=${isSignup ? "true" : "false"}`;
    interceptor
      .axiosPost("Post", url, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetUsers = (token, checked) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", `${APIPaths.users}?is_active=${!checked}`, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetUserById = (token, id) => {
  const url = `${APIPaths.users}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Step 4

export const AddLocations = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.location, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetLocations = (token, checked) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet(
        "Get",
        `${APIPaths.settingsLocation}?location_name=${checked}`,
        token,
        null
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Step 6

export const SendNotification = (
  token,
  model
) => {
  const method = "Post";
  const url = APIPaths.notifications;
  return new Promise((resolve, reject) => {
    interceptor[`axios${method}`](method, url, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetNotificationById = (token, id) => {
  const url = `${APIPaths.notifications}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetNotificationModel = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.notifications, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteNotification = (id, token) => {
  const url = `${APIPaths.notifications}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//dd call

export const GetProductTypes = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.product_type, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// onboarding create user account form
export const OnboardingCreateAccount = (model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosLogin("Post", APIPaths.create_account, model, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log(
          "error response on create user account onboarding : ",
          error?.response
        );
        reject(error?.response);
      });
  });
};
